import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { EventsListControllerModule } from './controllers/EventsListController';
import { CartServiceModule } from '@b2c/common/services/cart/cart.service';
import { EventsServiceModule } from '@b2c/common/services/events/events.service';
import { ComboServiceModule } from '@b2c/common/services/combo/combo.service';
import { CalendarServiceModule } from '@b2c/common/services/calendar/calendar.service';
import { MembershipServiceModule } from '@b2c/common/services/membership/membership.service';

export const EventsListView = angular.module( 'acme.view.events.list', [
  uiRouter,
  'ui.bootstrap',
  CartServiceModule,
  EventsServiceModule,
  ComboServiceModule,
  CalendarServiceModule,
  MembershipServiceModule,
  EventsListControllerModule
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var eventsList = {
        name: 'events.list',
        url: '/list?date&membershipIds',
        views: {
          "subview-main": {
            controller: 'EventsListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Plan Your Visit'
        },
        resolve: {
          EventsListData: ['$stateParams', 'EventsService', 'CalendarService', 'MembershipService', function($stateParams, EventsService, CalendarService, MembershipService) {

            var d = new Date(),
                startTime = CalendarService.toISO8601(new Date(d.getFullYear(), d.getMonth(), d.getDate()), 0, 0, 0),
                endTime = CalendarService.toISO8601(new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 0, 0, 0)),
                args: {
                  tenantId: string;
                  saleChannel: string;
                  startTime?: string;
                  endTime?: string;
                  membershipId?: string;
                } = {
                  tenantId: $stateParams.tenantId,
                  saleChannel: 'online'
                };

            if ($stateParams.date) {
              d = CalendarService.getParsableDate($stateParams.date);
              startTime = CalendarService.toISO8601(d.setHours(0));
              endTime = CalendarService.toISO8601(d.setHours(23));
              args.startTime = startTime;
              args.endTime = endTime;
            }

            if ($stateParams.membershipIds) {
              args.membershipId = MembershipService.getMembershipIds(true, $stateParams.membershipIds.split(',')).join() || null;
            } else {
              args.membershipId = MembershipService.getMembershipIds(true).join() || null;
            }

            console.log('EventsListData', args.membershipId, $stateParams, args);

            return EventsService.api.slimSummaries(args);

          }],

          ComboListData: ['$stateParams', 'ComboService', 'CalendarService', function($stateParams, ComboService, CalendarService) {
            return ComboService.api.list($stateParams.tenantId, { summary: true });
          }],

          CartData: [ '$stateParams', 'CartService', 'MembershipService', function($stateParams, CartService, MembershipService) {
            var isExpiredMembership = MembershipService.checkExpiredVerifiedMembership($stateParams.tenantId),
              membership = !isExpiredMembership && MembershipService.getVerifiedMember();

            return CartService.initCart({
              tenantId: $stateParams.tenantId,
              membershipId: isExpiredMembership ? null : membership.membershipId,
              membershipIds: isExpiredMembership ? null : MembershipService.getMembershipIds(true)
            });
          }]
        }
      };

    $stateProvider
      .state(eventsList);
}).name;
